+
<template>
  <!-- eslint-disable max-len -->
  <svg
    class="x-icon x-icon-xl"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.9997 22.8709C15.8063 22.8709 15.6495 23.0277 15.6495 23.2211C15.6495 23.4145 15.8063 23.5713 15.9997 23.5713C16.1931 23.5713 16.3498 23.4145 16.3498 23.2211C16.3498 23.0277 16.1931 22.8709 15.9997 22.8709ZM14.7332 23.2211C14.7332 22.5216 15.3002 21.9546 15.9997 21.9546C16.6991 21.9546 17.2662 22.5216 17.2662 23.2211C17.2662 23.7591 16.9307 24.2188 16.4574 24.4023V27.2633H15.5411V24.402C15.0683 24.2183 14.7332 23.7588 14.7332 23.2211ZM16.0453 30.103C14.5088 30.103 13.0918 29.0099 13.0918 27.3652H14.0081C14.0081 28.399 14.9032 29.1866 16.0453 29.1866C17.1873 29.1866 18.0824 28.399 18.0824 27.3652H18.9987C18.9987 29.0099 17.5818 30.103 16.0453 30.103Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.4668 16.4017C9.4668 13.7393 11.8046 10.4175 15.9998 10.4175C20.1997 10.4175 22.3782 13.4487 22.5323 16.3776L22.5329 16.3896V16.4017C22.5329 17.6206 22.4589 18.4076 22.1583 19.1059C21.8624 19.7932 21.3608 20.356 20.6397 21.1542C19.9962 21.9125 19.6896 22.5611 19.537 23.1728C19.381 23.7985 19.3789 24.4079 19.3789 25.1296V27.2511C19.3789 27.5675 19.1223 27.8238 18.8062 27.8238H13.2188C12.9051 27.8238 12.6461 27.5704 12.6461 27.2515V25.1296C12.6461 23.4679 11.9735 22.1121 11.3154 21.1024C11.1868 20.905 11.0432 20.7249 10.8797 20.5199C10.8459 20.4775 10.8113 20.434 10.7757 20.3892C10.5738 20.1342 10.3551 19.8466 10.1577 19.4959C9.75525 18.781 9.4668 17.8498 9.4668 16.4017ZM15.9998 11.3338C12.3507 11.3338 10.3831 14.2044 10.3831 16.4017C10.3831 17.7154 10.6416 18.4875 10.9562 19.0464C11.1173 19.3326 11.2996 19.5746 11.4942 19.8204C11.525 19.8593 11.5565 19.8987 11.5884 19.9387C11.7524 20.1442 11.9283 20.3645 12.0831 20.602C12.786 21.6804 13.5625 23.2141 13.5625 25.1296V26.9074H18.4625V25.106C18.4625 24.4079 18.4625 23.6947 18.6479 22.9511C18.8386 22.1865 19.2181 21.4116 19.9459 20.5555L19.9504 20.5502L19.9551 20.5451C20.7049 19.7151 21.0917 19.2661 21.3166 18.7436C21.5367 18.2323 21.616 17.612 21.6165 16.4139C21.4792 13.9045 19.6386 11.3338 15.9998 11.3338Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.28483 8.88578C3.4229 8.64663 3.72869 8.5647 3.96784 8.70277L8.40754 11.266C8.64669 11.4041 8.72863 11.7099 8.59055 11.949C8.45248 12.1882 8.14669 12.2701 7.90754 12.1321L3.46784 9.56879C3.22869 9.43072 3.14676 9.12493 3.28483 8.88578Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.62312 15.5425C1.62312 15.2663 1.84698 15.0425 2.12312 15.0425L7.24965 15.0425C7.52579 15.0425 7.74965 15.2663 7.74965 15.5425C7.74965 15.8186 7.52579 16.0425 7.24965 16.0425L2.12312 16.0425C1.84698 16.0425 1.62312 15.8186 1.62312 15.5425Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16 2.10408C16.2761 2.10408 16.5 2.32794 16.5 2.60408L16.5 7.7306C16.5 8.00675 16.2761 8.2306 16 8.2306C15.7239 8.2306 15.5 8.00675 15.5 7.7306L15.5 2.60408C15.5 2.32794 15.7239 2.10408 16 2.10408Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.85355 3.79606C9.0927 3.65799 9.39849 3.73993 9.53657 3.97907L12.0998 8.41877C12.2379 8.65792 12.156 8.96371 11.9168 9.10178C11.6777 9.23986 11.3719 9.15792 11.2338 8.91877L8.67054 4.47907C8.53247 4.23993 8.61441 3.93413 8.85355 3.79606Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28.932 8.88578C28.7939 8.64663 28.4881 8.5647 28.249 8.70277L23.8093 11.266C23.5701 11.4041 23.4882 11.7099 23.6262 11.949C23.7643 12.1882 24.0701 12.2701 24.3093 12.1321L28.749 9.56879C28.9881 9.43072 29.07 9.12493 28.932 8.88578Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M30.5937 15.5425C30.5937 15.2663 30.3698 15.0425 30.0937 15.0425L24.9672 15.0425C24.691 15.0425 24.4672 15.2663 24.4672 15.5425C24.4672 15.8186 24.691 16.0425 24.9672 16.0425L30.0937 16.0425C30.3698 16.0425 30.5937 15.8186 30.5937 15.5425Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23.3632 3.79606C23.1241 3.65799 22.8183 3.73993 22.6802 3.97907L20.117 8.41877C19.9789 8.65792 20.0608 8.96371 20.3 9.10178C20.5391 9.23986 20.8449 9.15792 20.983 8.91877L23.5463 4.47907C23.6843 4.23993 23.6024 3.93413 23.3632 3.79606Z"
      fill="currentColor"
    />
  </svg>
</template>
